export const $slack = {
  async notify(message: string, channel: "default" | "viewings" = "default") {
    console.log("Sending Slack notification to channel:", channel);
    console.log("Message:", message);
    const response = await fetch("/api/slack", {
      method: "POST",
      body: JSON.stringify({ message, channel }),
    });

    if (!response.ok) {
      throw new Error("Failed to send Slack notification");
    }

    return await response.json();
  },
};
